var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4787_3277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5555 0H8.74297C4.30215 0 0.699219 3.60293 0.699219 8.04375V34.8563C0.699219 39.2971 4.30215 42.9 8.74297 42.9H35.5555C39.9963 42.9 43.5992 39.2971 43.5992 34.8563V8.04375C43.5992 3.60293 39.9963 0 35.5555 0ZM13.9637 36.416H7.29922L7.26055 16.4613H13.925L13.9637 36.416ZM10.4639 13.851H10.4252C8.24668 13.851 6.8416 12.3492 6.8416 10.4801C6.8416 8.56582 8.2918 7.11563 10.509 7.11563C12.7262 7.11563 14.0861 8.56582 14.1313 10.4801C14.1313 12.3492 12.7197 13.851 10.4639 13.851ZM37.0701 36.416H30.3477V25.575C30.3477 22.9518 29.6516 21.1664 27.3055 21.1664C25.5137 21.1664 24.5469 22.3717 24.0828 23.5383C23.9088 23.9572 23.8637 24.5309 23.8637 25.1174V36.416H17.109L17.0703 16.4613H23.825L23.8637 19.2779C24.7273 17.9438 26.1646 16.0553 29.6064 16.0553C33.8732 16.0553 37.0637 18.8396 37.0637 24.8273V36.416H37.0701Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4787_3277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.9,
    height: 42.9,
    fill: "white",
    transform: "translate(0.699219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fd062afa916040d0565bd3537be6044c.svg";
export { ForwardRef as ReactComponent };